import { smStyle } from '@/components/Adapter'
import styled from 'styled-components'

export const PriceTableStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;

  &[data-tab='true'] {
    .price-table {
      margin-top: 8px;
    }
  }

  ${smStyle} {
    gap: 16px;
  }

  .hash-table {
    position: absolute;
    top: var(--header-height);
  }

  /** 新币特殊样式处理 */
  .gui-table-td:has(.price-new-right) {
    padding-right: 0 !important;
  }

  /** 新币特殊样式处理 */
  .gui-table-td:has(.price-new-left) {
    padding-left: 0 !important;
  }
`
